Vendd.Scripts.load(function () {

    $('.x-photogallery.x-photogallery-carousel.document-gallery').each(function (i, wrapper) {
        if (!$(wrapper).data('init'))
            return;

        var $control = $(wrapper),
            isBigDevice = ($(window).width() > 959) ? true : false;



        if (isBigDevice) {
            initCarousel($control);
        }

        initFB($control);


        var $normalWrapper = $('.photogallery-normal > ul', $control);

        $(window).on('resize', function () {

            if ($(window).width() < 960) {
                if ($normalWrapper.hasClass('slick-initialized')) {
                    $normalWrapper.slick('unslick');
                }
                return
            }

            if (!$normalWrapper.hasClass('slick-initialized')) {
                initCarousel($control);
                return;
            }

        });

    });

    $('.x-photogallery.new-model-gallery').each(function (i, control) {
        var $control = control;

        if ($control.length < 1)
            return;

        initFB();

        var $items = $('.gallery-thumbs > ul > li', $control);

        if ($items.length > 4) {
            var moreItems = $items.length - 4;
            $('.num-text', $control).html("+ " + moreItems).show();
        }

        function initFB() {
            var $fancyLinks = $('.pd-fancybox-gallery', $control);

            if ($fancyLinks.length < 1)
                return;

            var fbOpts = {
                nextEffect: 'fade',
                prevEffect: 'fade',
                nextSpeed: 300,
                prevSpeed: 300,
                loop  : true,
                btnTpl: {
                    smallBtn: '<a title="Close" data-fancybox-close class="fancybox-button fancybox-close-small fancybox-close icon-exit2 stylish-fancy-close" href="javascript:;"></a>',
                    arrowLeft: '<a data-fancybox-prev class="fancybox-button fancybox-button--arrow_left icon-arrow-light-left" title="{{PREV}}" href="javascript:;"></a>',
                    arrowRight: '<a data-fancybox-next class="fancybox-button fancybox-button--arrow_right icon-arrow-light-right" title="{{NEXT}}" href="javascript:;"></a>'
                },
                touch: false,
                infobar: false,
                baseClass: "full-height",
            };

            $fancyLinks.fancybox(fbOpts);
        }
    });

    $('.x-videogallery.new-model-gallery').each(function (i, control) {
        var $control = control;

        if ($control.length < 1)
            return;

        initCarousel();
        initFB();

        function initCarousel () {

            var $thumbs = $('.video-gallery-thumbs > ul', $control);
            var $mainGallery = $('.video-main-gallery > ul', $control);

            var numOfSlides = $('> li', $thumbs).length;

            if ($thumbs.length < 1)
                return;

            var $next = $('.video-nav-next', $control),
                $prev = $('.video-nav-prev', $control);

            var carouselThumbsOpts = {
                vertical: true,
                verticalSwiping: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                prevArrow: $('.video-gallery-thumbs .video-nav-prev'),
                nextArrow: $('.video-gallery-thumbs .video-nav-next'),
                asNavFor: '.video-main-gallery > ul',
            };

            var carouselMainOpts = {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                draggable: true,
                prevArrow: $('.video-main-gallery .video-nav-prev'),
                nextArrow: $('.video-main-gallery .video-nav-next'),
                asNavFor: '.video-gallery-thumbs > ul',
                dots: false,
                dotsClass: 'pagination'
            };

            $mainGallery.slick(carouselMainOpts);
            $thumbs.slick(carouselThumbsOpts);

            $('.thumb-item .image-container', $thumbs).click(function () {
                var index = $(this).parent().index();

                $mainGallery.slick('slickGoTo', index);
            });
        };

        function initFB() {
            var $fancyLinks = $('.pd-fancybox-gallery', $control);

            if ($fancyLinks.length < 1)
                return;

            var fbOpts = {
                padding: 0,
                nextEffect: 'fade',
                prevEffect: 'fade',
                nextSpeed: 300,
                prevSpeed: 300,
                tpl: {
                    wrap: '<div class="fancybox-wrap fan-1" tabIndex="-1"><div class="fancybox-skin spacer-container"><div class="fancybox-outer fan-2"><div class="fancybox-inner fan-3"></div></div></div></div>',
                    closeBtn: '<a title="Close" class="fancybox-item fancybox-close fancy-close icon-close" href="javascript:;"></a>',
                    next: '<a title="Next" class="fancybox-nav fancybox-next fancy-nav icon-arrow-light-right" href="javascript:;"><span></span></a>',
                    prev: '<a title="Previous" class="fancybox-nav fancybox-prev fancy-nav icon-arrow-light-left" href="javascript:;"><span></span></a>'
                }
            };

            $fancyLinks.fancybox(fbOpts);
        }

        $('.js-fancy-video').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('hello');
            var href = $(this).attr('href');
            $.fancybox.open({
                href: href,
                type: "iframe",
                openEffect: 'none',
                closeEffect: 'none',
                helpers: {
                            media: {}
                        },
                beforeShow: function () {
                    this.skin[0].className += ' fancybox-video-popup';
                }

            });

        });
    });


    function initCarousel($control) {

        var $normalWrapper = $('.photogallery-normal > ul', $control);
        var numOfSlides = $('> li', $normalWrapper).length;

        if ($normalWrapper.length < 1)
            return;

        var $next = $('.nav-next', $control),
            $prev = $('.nav-prev', $control);


        var carouselNormalOpts = {
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            draggable: false,
            prevArrow: $('.photogallery-normal .nav-prev'),
            nextArrow: $('.photogallery-normal .nav-next')
        };
        $normalWrapper.slick(carouselNormalOpts);
    }

    function destroyCarousel($control) {
        var $normalWrapper = $('.photogallery-normal > ul', $control);

        $normalWrapper.slick('unslick');
    }


    function initFB($wrapper) {
        var fbOpts = {
            padding: 0,
            margin: 0,
            autoSize: true,
            nextEffect: 'none',
            prevEffect: 'none',
            tpl: {
                wrap: '<div class="fancybox-wrap fan-1" tabIndex="-1"><div class="fancybox-skin spacer-container"><div class="fancybox-outer fan-2"><div class="fancybox-inner fan-3"></div></div></div></div>',
                closeBtn: '<a title="Close" class="fancybox-item fancybox-close fancy-close icon-close" href="javascript:;"></a>',
                next: '<a title="Next" class="fancybox-nav fancybox-next fancy-nav icon-arrow-light-right" href="javascript:;"><span></span></a>',
                prev: '<a title="Previous" class="fancybox-nav fancybox-prev fancy-nav icon-arrow-light-left" href="javascript:;"><span></span></a>'
            }
        };
        $('.fancylink', $wrapper).fancybox(fbOpts);
    }




});